/* P004/P020: use the existing Clarity installation; never load a second tracker. */
(() => {
  'use strict';
  if (window.P004Measurement) return;
  const script = document.currentScript;
  const pageType = script?.dataset.pageType || '';
  const preview = window.Shopify?.theme?.role !== 'main' || Boolean(window.Shopify?.designMode);
  const testSend = preview && new URLSearchParams(location.search).get('p004_measurement_test') === '1';
  const mode = preview ? (testSend ? 'test' : 'preview') : 'live';
  const seen = new Set();
  const pending = new Map();
  const ledger = [];
  let debugNode;
  if (preview) {
    debugNode = document.createElement('script');
    debugNode.type = 'application/json';
    debugNode.id = 'p004-measurement-debug';
    document.body.append(debugNode);
  }
  const record = (event, status) => {
    if (!debugNode) return;
    ledger.push({ event, status });
    if (ledger.length > 60) ledger.shift();
    debugNode.textContent = JSON.stringify({ version: 1, mode, events: ledger });
  };
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const deliver = (name, key) => {
    if (seen.has(key)) return;
    if (mode === 'preview') {
      seen.add(key);
      record(name, 'local_preview_only');
      return;
    }
    if (!allowed()) {
      record(name, 'blocked_consent');
      return;
    }
    if (typeof window.clarity !== 'function') {
      if (pending.size < 30) pending.set(key, name);
      record(name, 'waiting_for_existing_clarity');
      return;
    }
    try {
      const eventName = mode === 'test' ? name.replace('p004_', 'p004_test_') : name;
      window.clarity('event', eventName);
      seen.add(key);
      pending.delete(key);
      record(eventName, 'passed_to_clarity');
    } catch {
      record(name, 'receiver_error');
    }
  };
  const root = () => document.querySelector('p040-product-comparison');
  const compare = (ids, kind) => {
    const valid = [...new Set(ids.map(String).filter(id => /^\d+$/.test(id)))].sort();
    if (valid.length < 2 || valid.length > 3) return;
    deliver('p004_compare_selection', 'selection:' + kind + ':' + valid.join(','));
  };
  const open = () => {
    if (root()) deliver('p004_compare_open', 'open');
  };
  window.P004Measurement = Object.freeze({ compare });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || (event.button !== undefined && event.button !== 0)) return;
    const link = event.target.closest?.('p040-product-comparison a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    if (url.origin !== location.origin || !/\/(?:products)\/[^/]+\/?$/.test(url.pathname)) return;
    // A product visit is counted once per product/variant and page visit.
    const variant = url.searchParams.get('variant');
    deliver('p004_compare_product_visit', 'product:' + url.pathname + ':' + (variant && /^\d+$/.test(variant) ? variant : ''));
  });
  const approvedVideos = new Set(['70388255260997','70388166394181','65331696140613','70411290640709','70411267768645','70411228709189','70411316527429','72689819681093']);
  const mediaId = video => {
    if (pageType !== 'product' || video?.tagName !== 'VIDEO' || !video.closest('media-gallery, product-modal')) return null;
    const raw = video.closest('[data-media-id]')?.dataset.mediaId || video.closest('deferred-media')?.querySelector('[id^="Deferred-Poster-"]')?.id || '';
    const id = raw.match(/(\d+)$/)?.[1];
    return approvedVideos.has(id) ? id : null;
  };
  document.addEventListener('playing', event => {
    const id = mediaId(event.target);
    if (id) deliver('p004_video_start', 'video_start:' + id);
  }, true);
  document.addEventListener('ended', event => {
    const id = mediaId(event.target);
    if (id && seen.has('video_start:' + id)) {
      deliver('p004_video_complete', 'video_complete:' + id);
    }
  }, true);
  const refresh = () => {
    if (!allowed() && mode !== 'preview') { pending.clear(); return; }
    for (const [key, name] of pending) deliver(name, key);
    open();
    // Current selection after consent; never replay earlier denied interactions.
    const comparison = root();
    if (comparison?.selectedSection && !comparison.selectedSection.hidden) {
      compare(comparison.selection().map(item => comparison.variant(item).id), comparison.kind);
    }
  };
  document.addEventListener('visitorConsentCollected', refresh);
  open();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) refresh(); });
  } else refresh();
  // This opt-in test control is rendered only for an explicit draft test URL.
  // It updates this browser's analytics choice through Shopify's normal API.
  if (mode === 'test') {
    const panel = document.createElement('details');
    panel.id = 'p004-measurement-test-controls';
    const summary = document.createElement('summary');
    summary.textContent = 'Messung im Entwurf testen';
    panel.append(summary);
    const hint = document.createElement('p');
    hint.textContent = 'Nur dieser Browsertest. Ereignisse tragen den Zusatz test. Es werden keine Produktentscheidungen oder Formulareingaben übertragen.';
    panel.append(hint);
    for (const [label, value] of [['Analyse für diesen Browsertest erlauben', true], ['Analyse wieder ablehnen', false]]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.addEventListener('click', () => {
        if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
          window.Shopify.customerPrivacy.setTrackingConsent({ analytics: value }, refresh);
        }
      });
      panel.append(button);
    }
    document.body.append(panel);
  }
  let attempts = 0;
  const readiness = setInterval(() => {
    refresh();
    if (++attempts >= 15 || (typeof window.clarity === 'function' && window.Shopify?.customerPrivacy)) clearInterval(readiness);
  }, 1000);
})();
